'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Types of Button Color Types
var ButtonStyles = /*#__PURE__*/function (ButtonStyles) {
  ButtonStyles["DEFAULT"] = "default";
  ButtonStyles["BLACK"] = "black";
  ButtonStyles["GREY"] = "grey";
  ButtonStyles["LINK_BLUE"] = "link-blue";
  ButtonStyles["MLB_TV_ORANGE"] = "mlb-tv-orange";
  ButtonStyles["SELECTED_TAB"] = "selected-tab";
  ButtonStyles["TEAM"] = "team";
  ButtonStyles["TICKET_LINK_GREEN"] = "ticket-link-green";
  return ButtonStyles;
}({});

// Types of Button Styles
var ButtonShapes = /*#__PURE__*/function (ButtonShapes) {
  ButtonShapes["HOLLOW"] = "hollow";
  ButtonShapes["HOLLOW_BORDERLESS"] = "hollow-borderless";
  ButtonShapes["PILL"] = "pill";
  ButtonShapes["PILL_SOLID"] = "pill-solid";
  ButtonShapes["SOLID"] = "solid";
  ButtonShapes["TAB"] = "tab";
  return ButtonShapes;
}({});

// Button Sizes
var ButtonSizes = /*#__PURE__*/function (ButtonSizes) {
  ButtonSizes["XSMALL"] = "xs";
  ButtonSizes["SMALL"] = "sm";
  ButtonSizes["MEDIUM"] = "md";
  ButtonSizes["LARGE"] = "lg";
  ButtonSizes["XLARGE"] = "xl";
  return ButtonSizes;
}({});

// Button Types
var ButtonTypes = /*#__PURE__*/function (ButtonTypes) {
  ButtonTypes["BUTTON"] = "button";
  ButtonTypes["RESET"] = "reset";
  ButtonTypes["SUBMIT"] = "submit";
  return ButtonTypes;
}({});

// All the props for the Button Component

// A map of the various sizes detailing various styling tweaks per size
var buttonSizeMap = {
  xs: {
    fontSize: 12,
    height: 24,
    horizontalPadding: 10,
    iconSize: 13,
    iconPaddingTop: 1
  },
  sm: {
    fontSize: 13,
    height: 32,
    horizontalPadding: 10,
    iconSize: 14,
    iconPaddingTop: 1
  },
  md: {
    fontSize: 15,
    height: 36,
    horizontalPadding: 10,
    iconSize: 16,
    iconPaddingTop: 1
  },
  lg: {
    fontSize: 18,
    height: 42,
    horizontalPadding: 15,
    iconSize: 18,
    iconPaddingTop: 1
  },
  xl: {
    fontSize: 20,
    height: 48,
    horizontalPadding: 20,
    iconSize: 18,
    iconPaddingTop: 2
  }
};

exports.ButtonShapes = ButtonShapes;
exports.ButtonSizes = ButtonSizes;
exports.ButtonStyles = ButtonStyles;
exports.ButtonTypes = ButtonTypes;
exports.buttonSizeMap = buttonSizeMap;
